import { Loadable, LoadableOf, UnbalanceUnit } from '@schenck/rotec-components';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

export interface StatisticsDateRangeAndIds {
  /**
   * Time range start.
   */
  from: Date;
  /**
   * Time range end.
   */
  to: Date;
  /**
   * For which machine serials to retrieve the statistics.
   */
  machineSerials: string[];
}

/**
 * This is the request interface for all backend statistics calls.
 */
export interface StatisticsApiRequest {
  /**
   * The main asset to get statistics for.
   */
  main: StatisticsDateRangeAndIds;
  /**
   * Possibly a compare asset to get statistics for.
   */
  compare?: StatisticsDateRangeAndIds;
  /**
   * For which rotor type to get the statistics.
   */
  rotorType?: string;
  /**
   * Which unit the unbalance data should be in.
   */
  unbalUnit?: UnbalanceUnit;
}

export interface MainCompare<T> {
  main: T;
  compare?: T;
}

/**
 * Convenience rxjs operator to switchMap the success result.
 */
export function switchMapLoadableResult<T, U>(mapper: (t: T) => Observable<U>) {
  return switchMap<LoadableOf<T>, Observable<LoadableOf<U>>>((loadable) => {
    return Loadable.mapLoadableResult$(loadable, mapper);
  });
}

/**
 * Convenience rxjs operator to map the success result.
 */
export function mapLoadableResult<T, U>(mapper: (t: T) => U) {
  return map<LoadableOf<T>, LoadableOf<U>>((loadable) => {
    return Loadable.mapLoadableResult(loadable, mapper);
  });
}

export function replaceDatesWithISOStrings(request: { from: Date; to: Date }): {
  from: string;
  to: string;
} {
  return { from: request.from.toISOString(), to: request.to.toISOString() };
}
